import baseStore from './baseStore'

const state = {
  ...baseStore.state,
  modelDisplayNames: ['transaction', 'transactions'],
  modelName: 'transaction',
}

const mutations = {
  ...baseStore.mutations
}

const actions = {
  ...baseStore.actions
}

const getters = {
  ...baseStore.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
